/** Empty-state block. Keeps "no data" visually distinct from "failed to load". */
import React from "react";

interface EmptyStateProps {
  title: string;
  description?: React.ReactNode;
  icon?: React.ReactNode;
  action?: React.ReactNode;
}

export default function EmptyState({ title, description, icon, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 py-16 text-center">
      {icon ? <div className="mb-1 text-content-subtle">{icon}</div> : null}
      <p className="text-sm font-semibold text-content">{title}</p>
      {description ? (
        <p className="max-w-md text-xs leading-relaxed text-content-muted">{description}</p>
      ) : null}
      {action ? <div className="mt-3">{action}</div> : null}
    </div>
  );
}
